import React from 'react';

const ProjectProgressBar = ({ percentage, size = 'default' }) => {
  const sizeClasses = {
    sm: 'h-1.5',
    default: 'h-2 md:h-2.5',
    lg: 'h-3 md:h-4'
  };

  const getProgressColor = (percent) => {
    if (percent >= 75) return 'bg-green-500';
    if (percent >= 50) return 'bg-amber-500';
    if (percent >= 25) return 'bg-orange-500';
    return 'bg-red-500';
  };

  return (
    <div className="w-full">
      <div className={`w-full bg-muted rounded-full overflow-hidden ${sizeClasses?.[size]}`}>
        <div
          className={`${getProgressColor(percentage)} ${sizeClasses?.[size]} rounded-full transition-all duration-300`}
          style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
        />
      </div>
      <span className="text-xs md:text-sm text-muted-foreground mt-1 block">
        {percentage}% Complete
      </span>
    </div>
  );
};

export default ProjectProgressBar;